import Navbar from '@/components/layout/Navbar'
import Footer from '@/components/layout/Footer'
import HeroSection from '@/components/home/HeroSection'
import WhatAreYouBuildingSection from '@/components/home/WhatAreYouBuildingSection'
import PositioningSection from '@/components/home/PositioningSection'
import ServicesSection from '@/components/home/ServicesSection'
import GCCJourneySection from '@/components/home/GCCJourneySection'
import CapabilitiesSection from '@/components/home/CapabilitiesSection'
import StatsSection from '@/components/home/StatsSection'
import FourFactorSection from '@/components/home/FourFactorSection'
import WhyStriveSection from '@/components/home/WhyStriveSection'
import SuccessStoriesSection from '@/components/home/SuccessStoriesSection'
import AboutTeaser from '@/components/home/AboutTeaser'
import FinalCTA from '@/components/home/FinalCTA'

export default function HomePage() {
  return (
    <main data-testid="home-page">
      <Navbar />
      <HeroSection />
      <WhatAreYouBuildingSection />
      <PositioningSection />
      <ServicesSection />
      <GCCJourneySection />
      <CapabilitiesSection />
      <StatsSection />
      <FourFactorSection />
      <WhyStriveSection />
      <SuccessStoriesSection />
      <AboutTeaser />
      <FinalCTA />
      <Footer />
    </main>
  )
}
